import axios from "axios"
import Cookies from 'universal-cookie';

function updateCartAPI() {
  let orderedProducts = []

  let cart = getCart();

  cart.forEach(x => {
    orderedProducts.push({
      product: 'api/products/' + x.id,
      quantity: x.quantity
    })
  });

  const cookies = new Cookies();

  if (window.localStorage.getItem('kabaaShop-CartID') !== null) {
    axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/orders/' + window.localStorage.getItem('kabaaShop-CartID'),
      {
        orderedProducts: orderedProducts
      }, {
      headers: {
        'x-api-token': cookies.get('user').setToken
      }
    }).then(a => {
    }).catch(error => {
      console.log(error);
    })
  }
  else {

    axios.post(process.env.REACT_APP_API_BASE_URL + '/api/orders',
      {
        user: 'api/users/' + cookies.get('user').id,
        status: 'cart',
        orderedProducts: orderedProducts
      }, {
      headers: {
        'x-api-token': cookies.get('user').setToken
      }
    }).then(a => {
      window.localStorage.setItem('kabaaShop-CartID', a.data.id)
    }).catch(error => {
      console.log(error);
    })
  }
}
//Storage Panier
export function getCart() {
  return window.localStorage.getItem('kabaaShop-Cart') !== null ?
    JSON.parse(window.localStorage.getItem('kabaaShop-Cart')) :
    []
}

export function setCartID(id) {
  window.localStorage.setItem('kabaaShop-CartID', id)
}

export function getCartID() {
  return window.localStorage.getItem('kabaaShop-CartID') !== null ?
    window.localStorage.getItem('kabaaShop-CartID') :
    null
}

export function setCart(cart) {
  window.localStorage.setItem('kabaaShop-Cart', JSON.stringify(cart))

  const cookies = new Cookies();

  if (cookies.get('user')) {
    updateCartAPI()
  }

  return getCart();
}

export function deleteCart() {
  window.localStorage.removeItem('kabaaShop-Cart');
  window.localStorage.removeItem('kabaaShop-CartID');

  return getCart();
}

export function isProductInCart(productId) {
  let cart = getCart();

  return cart.find(x => x.id === productId) !== undefined ?
    true :
    false
}

export function addProductInCart(product, qty = 1) {
  let cart = getCart();

  cart.push({
    id: product.id,
    priceToPay: product.discount ? (product.price - Math.round(product.price * product.discount / 100)) : product.price,
    quantity: qty,
    name: product.name,
    image: product.thumb
  })

  setCart(cart)

  return getCart();
}

//Storage Favoris
export function getFavourites() {
  return window.localStorage.getItem('kabaaShop-Favourites') !== null ?
    JSON.parse(window.localStorage.getItem('kabaaShop-Favourites')) :
    []
}

export function setFavourites(favourites) {
  window.localStorage.setItem('kabaaShop-Favourites', JSON.stringify(favourites))

  const cookies = new Cookies();

  if (cookies.get('user')) {
    updateFavouritesAPI()
  }

  return getFavourites();
}

function updateFavouritesAPI() {
  let products = []

  let favs = getFavourites();

  const cookies = new Cookies();

  favs.forEach(x => {
    products.push({
      product: 'api/products/' + x.id
    })
  });
  
  axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/users/' + cookies.get('user').id,
    {
      favourites: products
    }, {
    headers: {
      'x-api-token': cookies.get('user').setToken
    }
  }).then(a => {
  }).catch(error => {
    console.log(error);
  })
}

export function deleteFavourites() {
  window.localStorage.removeItem('kabaaShop-Favourites');

  return getFavourites();
}

export function isProductInFavourites(productId) {
  let favourites = getFavourites();
  return favourites.find(x => x.id === productId) !== undefined ?
    true :
    false
}

export function addProductInFavourites(product) {
  let favourites = getFavourites();
  favourites.push({
    id: product.id,
    priceToPay: product.discount ? (product.price - Math.round(product.price * product.discount / 100)) : product.price,
    name: product.name,
    image: product.thumb,
    slug: product.slug
  })

  setFavourites(favourites)

  return getFavourites();
}